export default __webpack_public_path__ + "static/media/icon_ihmiset_lukittu.53b40573.svg";